import { t as tr } from './i18n';
import type { Rfq, RfqState, Send } from './types';

export interface SendStatus {
  cls: 'got' | 'todo' | 'wait' | 'late';
  /** în limba de acum */
  txt: string;
}

/**
 * Starea unui furnizor pe o cerere. Portat din `status()` din demo, plus
 * „De trimis": mailul pleacă din programul de mail al omului, deci până apasă
 * „Am trimis" nu așteptăm nimic de la furnizor. Bate termenul depășit, fiindcă
 * singurul lucru de făcut e să trimiți mailul.
 */
export function status(
  send: Pick<Send, 'offer' | 'sentAt'>,
  rfq: Pick<Rfq, 'deadline'>,
  now: number = Date.now(),
): SendStatus {
  if (send.offer) return { cls: 'got', txt: tr('Ofertă primită') };
  if (!send.sentAt) return { cls: 'todo', txt: tr('De trimis') };
  const late = new Date(`${rfq.deadline}T23:59:59`).getTime() < now;
  if (late) return { cls: 'late', txt: tr('Termen depășit') };
  return { cls: 'wait', txt: tr('Așteaptă răspuns') };
}

/**
 * Starea unei cereri. Trei, nu două: „închisă" înseamnă dusă până la capăt,
 * „anulată" înseamnă că s-a renunțat și nu s-a cumpărat nimic. Amestecate,
 * istoricul șantierului ar pretinde că s-a cumpărat ceva de fiecare dată.
 *
 * Anularea bate închiderea: o cerere anulată după ce fusese închisă rămâne
 * anulată, fiindcă asta e ultima veste despre ea.
 */
export function rfqState(r: Pick<Rfq, 'closedAt' | 'canceledAt'>): RfqState {
  if (r.canceledAt) return 'canceled';
  if (r.closedAt) return 'closed';
  return 'open';
}
